import { FC } from 'react';

import styles from './Footer.module.css';

const Footer: FC = () => {
  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={styles.footerContent}>
        <div className={styles.contactInfo}>
          <span>205.382.8050</span>
          <span className={styles.separator}>•</span>
          <span>info@tireswingpestsolutions.com</span>
          <span className={styles.separator}>•</span>
          <span>208 Laurel Dr, Gardendale, AL 35071</span>
        </div>
        <p className={styles.copyright}>Made by Derek Mackley &copy; {new Date().getFullYear()}</p>
      </div>
    </footer>
  );
};

export default Footer;
